var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.damWB)?_c('l-geo-json',{attrs:{"geojson":_vm.damWB,"options":{ onEachFeature: _vm.onEachFeature },"optionsStyle":_vm.getWBStyle}}):_vm._e(),(_vm.damPoint)?_c('l-geo-json',{attrs:{"geojson":_vm.damPoint,"options":{ onEachFeature: _vm.onEachFeature, pointToLayer: _vm.pointToLayer }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }